import { render, staticRenderFns } from "./PhotovoltaicFormGroup.vue?vue&type=template&id=b962faf4&"
import script from "./PhotovoltaicFormGroup.vue?vue&type=script&lang=ts&"
export * from "./PhotovoltaicFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports